function nameFromEmail(email) {
  const e = String(email ?? "").trim();
  const at = e.indexOf("@");
  if (at <= 0) return "";
  return e.slice(0, at).trim();
}

function isMeaninglessNamePart(part) {
  const s = String(part ?? "").trim().toLowerCase();
  return !s || s === "null" || s === "undefined";
}

export function isMeaninglessPlayerName(name) {
  const n = String(name ?? "").trim();
  if (!n) return true;
  if (/^null(\s+null)*$/i.test(n)) return true;
  const parts = n.split(/\s+/).filter(Boolean);
  return parts.length > 0 && parts.every(isMeaninglessNamePart);
}

/** Display / API name: user fields, else email local-part (e.g. kkk@extramile.in → kkk). */
export function resolvePlayerName(user) {
  if (!user || typeof user !== "object") return "";

  const raw = user.name;
  if (typeof raw === "string") {
    const t = raw.trim();
    if (t && !isMeaninglessPlayerName(t)) return t;
  }

  const fn = user.firstName ?? user.first_name;
  const ln = user.lastName ?? user.last_name;
  const parts = [fn, ln].filter((p) => !isMeaninglessNamePart(p));
  const joined = parts.map((p) => String(p).trim()).join(" ").trim();
  if (joined) return joined;

  return nameFromEmail(user.email || user.employeeId || user.emp_id);
}
